import React from "react";

const NotAuthorized = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#f8d7da",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div
        style={{
          background: "#ffffff",
          padding: "2rem 3rem",
          borderRadius: "8px",
          boxShadow: "0 0 10px rgba(0,0,0,0.1)",
          textAlign: "center",
        }}
      >
        <h1 style={{ color: "#721c24", marginBottom: "1rem" }}>Access Denied</h1>
        <p style={{ color: "#721c24" }}>
          You do not have permission to access this page.
        </p>
      </div>
    </div>
  );
};

export default NotAuthorized;
